<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WTpWFv/tc-custom/9783987448898.jpg?1704424708318" alt="This image is the cover for the book Summer, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Summer, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Summer is about a young woman's pride, independence and honesty through the character of Charity Royall. Along with her story is that of Lawyer Royall. It is the story of two protagonists who must come to terms with destructive illusions in order to lead adult lives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edith Wharton
      </h2>
      
      <p class="authorDescription body article">Edith Wharton (born Edith Newbold Jones; January 24, 1862 – August 11, 1937) was an American novelist, short story writer, and interior designer. Wharton drew upon her insider's knowledge of the upper class New York "aristocracy" to realistically portray the lives and morals of the Gilded Age. In 1921, she became the first woman to win the Pulitzer Prize in Literature, for her novel The Age of Innocence. She was inducted into the National Women's Hall of Fame in 1996. Among her other well known works are The House of Mirth and the novella Ethan Frome.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b294f4f0